(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('EconomicGroupFranchiserListController', EconomicGroupFranchiserListController)

    /** @ngInject */
    function EconomicGroupFranchiserListController($httpParamSerializer, HelperService, EconomicGroupService, ROUTES, ReportDownloadService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getGroups(start, number, tableState);
        }

        vm.configureReportDownload = () => {
            const parameters = prepareParameters(0, 0, null);

            return ReportDownloadService.download('economic-groups-report', parameters);
        }

        init();

        function getGroups(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            EconomicGroupService
                .getByParameters(parameters)
                .then(success => {
                    vm.groups = success.Groups;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.groups = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: false
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                    Value: 'ExternalCode',
                    Description: 'Código Externo'
                },
                {
                    Value: 'Description',
                    Description: 'Descrição'
                }
            ];
        }
    }
}());